export default __webpack_public_path__ + "static/media/card-w-product@2x.6656dd04.png";